import { graphql } from '@/generated/gql';

export const SUPPLIER_RISKS_WIDGET_QUERY = graphql(/* GraphQL */ `
  query SupplierRisksWidget($id: UUID!) {
    cataclysm {
      supplier(id: $id) {
        id
        risks {
          id
          name
          description
          score
          riskCategoryId
        }
      }
    }
  }
`);
